"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.eth_accounts = exports.eth_sendTransaction = void 0;
const web3_1 = __importDefault(require("web3"));
const java_tron_provider_1 = require("@intercroneswap/java-tron-provider");
const utils_js_1 = require("./utils.js");
// ensures abi is tronweb compatible (new tronweb assumes abi contains
// stateMutability prop but ABIs generated with older solc lack that prop)
function normalizeAbi(abi) {
    // https://solidity.readthedocs.io/en/v0.5.10/abi-spec.html#json
    let stateMutability = abi.stateMutability;
    if (!abi.stateMutability) {
        if (abi.constant) {
            stateMutability = "view";
        }
        else {
            if (abi.payable) {
                stateMutability = "payable";
            }
            else {
                stateMutability = "nonpayable";
            }
        }
    }
    return Object.assign({ stateMutability }, abi);
}
function triggerSmartContract(params, ctx) {
    return __awaiter(this, void 0, void 0, function* () {
        const tronweb = ctx.tronweb;
        const { params: fnParams, functionAbi } = utils_js_1.decodeFunctionCall(params.data, ctx.functionSignatures);
        const contract = tronweb.contract([normalizeAbi(functionAbi)], java_tron_provider_1.ethAddress.toTronHex(params.to));
        const callValue = web3_1.default.utils.hexToNumber(params.value);
        const sendParams = Object.assign({ callValue }, (params.gas
            ? { feeLimit: web3_1.default.utils.hexToNumberString(params.gas) }
            : {}));
        console.log({ web3params: params, tronLinkParams: sendParams });
        const txHash = yield contract.methods[functionAbi.name](...fnParams).send(sendParams);
        return `0x${txHash}`;
    });
}
function simpleTransfer(params, ctx) {
    return __awaiter(this, void 0, void 0, function* () {
        const amount = web3_1.default.utils.hexToNumber(params.value);
        const to = java_tron_provider_1.ethAddress.toTron(params.to);
        const res = yield ctx.tronweb.trx.sendTransaction(to, amount);
        return `0x${res.txid}`;
    });
}
function eth_sendTransaction([params], ctx) {
    return __awaiter(this, void 0, void 0, function* () {
        if (params.data) {
            return triggerSmartContract(params, ctx);
        }
        // TODO: simple transfer...
        return simpleTransfer(params, ctx);
    });
}
exports.eth_sendTransaction = eth_sendTransaction;
function eth_accounts(_params, ctx) {
    const tronweb = ctx.tronweb;
    const defaultAddress = java_tron_provider_1.ethAddress.fromTronHex(tronweb.defaultAddress.hex);
    return [defaultAddress];
}
exports.eth_accounts = eth_accounts;
// TODO: eth_chainId .. should return chain selected in tronlink, not the one
// from createTronLinkProvider({ network })...
